import { render } from "./QuizCallout.vue?vue&type=template&id=7f16b784"
import script from "./QuizCallout.vue?vue&type=script&lang=js"
export * from "./QuizCallout.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./QuizCallout.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_49ef5a74%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fhome%2FQuizCallout.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__